// Known JSX quirk: the Positive cell has a self-closing span followed by the
// value rendered outside the span — preserved verbatim from the original.

import React from "react";
import { Typography, Button } from "@material-tailwind/react";
import Pagination from "components/pagination";
import {
    GobbyTable,
    GobbyTableHead,
    GobbyTableBody,
    GobbyTableRow,
    GobbyTableHeader,
    GobbyTableCell,
} from "components/ui/gobby-table";

export function RespondentSentimentSection({
    respondentSentimentData,
    respondentSentimentPage,
    setRespondentSentimentPage,
    setResponseSentimentListId,
    setShowRespondentResponseSentimentListDialog,
}) {
    return (
        <div>
            <Typography
                variant="h4"
                className="ml-2 text-black w-2/3"
            >
                Respondents Sentiment
            </Typography>
            <div className="rounded-lg bg-white mt-2 w-full">
                {!!respondentSentimentData?.data && (
                    <>
                        <GobbyTable>
                            <GobbyTableHead className="text-center">
                                <GobbyTableRow>
                                    <GobbyTableHeader className="border-b-2 font-body w-3/12">
                                        Respondent ID
                                    </GobbyTableHeader>
                                    <GobbyTableHeader className="border-b-2 font-body w-1/12">
                                        Mixed
                                    </GobbyTableHeader>
                                    <GobbyTableHeader className="border-b-2 font-body w-1/12">
                                        Positive
                                    </GobbyTableHeader>
                                    <GobbyTableHeader className="border-b-2 font-body w-1/12">
                                        Neutral
                                    </GobbyTableHeader>
                                    <GobbyTableHeader className="border-b-2 font-body w-1/12">
                                        Negative
                                    </GobbyTableHeader>
                                    <GobbyTableHeader className="border-b-2 font-body w-5/12">
                                        Respondent Answers
                                    </GobbyTableHeader>
                                </GobbyTableRow>
                            </GobbyTableHead>
                            <GobbyTableBody className="text-black">
                                {respondentSentimentData.data.map(
                                    (respondent, index) => (
                                        <GobbyTableRow
                                            key={
                                                respondent.respondent_id
                                            }
                                        >
                                            <GobbyTableCell className="text-center">
                                                {
                                                    respondent.respondent_id
                                                }
                                            </GobbyTableCell>
                                            <GobbyTableCell>
                                                <span
                                                    className={`font-body px-4 ${
                                                        respondent
                                                            .respondent_sentiment
                                                            .mixed ===
                                                        respondent
                                                            .respondent_sentiment
                                                            .highest
                                                            ? "font-bold rounded-full text-center"
                                                            : ""
                                                    }`}
                                                >
                                                    {
                                                        respondent
                                                            .respondent_sentiment
                                                            .mixed
                                                    }
                                                </span>
                                            </GobbyTableCell>
                                            <GobbyTableCell>
                                                <span
                                                    className={`font-body px-4 ${
                                                        respondent
                                                            .respondent_sentiment
                                                            .positive ===
                                                        respondent
                                                            .respondent_sentiment
                                                            .highest
                                                            ? "font-bold rounded-full text-center"
                                                            : ""
                                                    }`}
                                                ></span>
                                                {
                                                    respondent
                                                        .respondent_sentiment
                                                        .positive
                                                }
                                            </GobbyTableCell>
                                            <GobbyTableCell>
                                                <span
                                                    className={`font-body px-4 ${
                                                        respondent
                                                            .respondent_sentiment
                                                            .neutral ===
                                                        respondent
                                                            .respondent_sentiment
                                                            .highest
                                                            ? "font-bold rounded-full text-center"
                                                            : ""
                                                    }`}
                                                >
                                                    {
                                                        respondent
                                                            .respondent_sentiment
                                                            .neutral
                                                    }
                                                </span>
                                            </GobbyTableCell>
                                            <GobbyTableCell>
                                                <span
                                                    className={`font-body px-4 ${
                                                        respondent
                                                            .respondent_sentiment
                                                            .negative ===
                                                        respondent
                                                            .respondent_sentiment
                                                            .highest
                                                            ? "font-bold rounded-full text-center"
                                                            : ""
                                                    }`}
                                                >
                                                    {
                                                        respondent
                                                            .respondent_sentiment
                                                            .negative
                                                    }
                                                </span>
                                            </GobbyTableCell>
                                            <GobbyTableCell className="text-center">
                                                <Button
                                                    type="button"
                                                    variant="filled"
                                                    className="btn btn--secondary"
                                                    onClick={() => {
                                                        setResponseSentimentListId(
                                                            index,
                                                        );
                                                        setShowRespondentResponseSentimentListDialog(
                                                            true,
                                                        );
                                                    }}
                                                >
                                                    View Responses
                                                </Button>
                                            </GobbyTableCell>
                                        </GobbyTableRow>
                                    ),
                                )}
                            </GobbyTableBody>
                        </GobbyTable>
                        <Pagination
                            currentPage={
                                respondentSentimentData?.pager
                                    ?.current_page || respondentSentimentPage
                            }
                            lastPage={
                                respondentSentimentData?.pager?.last_page
                            }
                            onPageChange={setRespondentSentimentPage}
                        />
                    </>
                )}
            </div>
        </div>
    );
}
